/** Shared max-width for discover content and landing navbar inner column. */
export const CONTENT_MAX_WIDTH = 1414;

/** Landing footer content max width. */
export const FOOTER_MAX_WIDTH = 1200;

/** Standard horizontal page padding across public and portal pages. */
export const PAGE_PADDING_X = { base: 16, sm: 20, md: 24 } as const;

/**
 * Sidebar-aware layout rules (pages inside AppShell):
 * - Stack side panels at `xl` (1400px), not `lg` (1200px) — content column is ~750–850px at 125% scaling.
 * - Tab dropdown when tabCount >= 5 and viewport < lg (see useNavTabsStackLayout).
 * - Profile headers stack logo/details/action below `lg`.
 */
export const SIDEBAR_AWARE_GRID = {
  /** Main + sidebar column split (8/4) — stacks until xl */
  mainWithSidebar: { main: { base: 12, xl: 8 }, sidebar: { base: 12, xl: 4 } },
  /** Profile body two-column (7/5) — stacks until lg */
  profileBody: { main: { base: 12, lg: 7 }, aside: { base: 12, lg: 5 } },
  /** Standard full-width */
  full: { base: 12 },
} as const;
